import { useT } from '../hooks';

interface Props {
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Guards the exits during a live round. Leaving mid-game is a forfeit, which is
 * not something to do by mis-clicking the brand mark.
 */
export function LeaveConfirm({ onStay, onLeave }: Props) {
  const t = useT();
  return (
    <div className="modal-backdrop" onClick={onStay}>
      <div className="modal modal--sm" onClick={(e) => e.stopPropagation()} role="alertdialog">
        <h2 className="modal__title">{t.leave.title}</h2>
        <p className="muted">{t.leave.body}</p>
        <div className="modal__actions">
          <button type="button" className="btn btn--ghost" onClick={onLeave}>
            {t.leave.confirm}
          </button>
          <button type="button" className="btn btn--primary" autoFocus onClick={onStay}>
            {t.leave.stay}
          </button>
        </div>
      </div>
    </div>
  );
}
